export type Coordinates = { latitude: number; longitude: number };

// Ett tal med valfri decimaldel, där decimaltecknet kan vara punkt eller komma.
const NUMBER = /-?\d+(?:[.,]\d+)?/g;

/**
 * Tolkar en inklistrad koordinat, "lat, long". Klarar både Google Maps format
 * ("59.3293, 18.0686") och svenska decimalkomman ("59,3293 18,0686"). Returnerar null om det inte
 * är exakt två tal, eller om talen inte kan vara en latitud och en longitud.
 *
 * Rimlighetskontrollen här är bara den grova; servern avvisar dessutom allt utanför Norden.
 */
export const parseCoordinates = (text: string): Coordinates | null => {
  const numbers = text.match(NUMBER);
  if (!numbers || numbers.length !== 2) return null;

  const [latitude, longitude] = numbers.map((n) => Number(n.replace(',', '.')));
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;

  return { latitude, longitude };
};
